import { GATING } from './CommonConstants';

const { DISCONTINUE, TESTED_OUT } = GATING;
const ZERO = 0;

export const ASTERISK = '*';
export const LONG_DASH = '—';
export const LIST = 'list';
export const GOAL = 'goal';
export const GOAL_TITLE = 'Goal';

export const CELL_MEASUREMENTS = {
    DEFAULT: {
        cellHeight: 40,
        cellWidth: 80,
        isCellHeightFixed: false,
    },
    DEFAULT_BENCHMARK: {
        cellHeight: 80,
        cellWidth: 80,
    },
};

export const AMP_NAV_HEIGHT = 35;

export const CELL_TYPE = {
    BENCHMARK: 'BENCHMARK_CELL_TYPE',
    STUDENT_SUMMARY: 'STUDENT_SUMMARY_CELL_TYPE',
    INPUT: 'INPUT_CELL_TYPE',
    BENCHMARK_GATING_MEASURE: 'BENCHMARK_GATING_MEASURE_CELL_TYPE',
    SS_GATING_MEASURE: 'SS_GATING_MEASURE_CELL_TYPE',
};

export const INDEX = {
    FIRST_ARRAY_INDEX: ZERO,
    FIRST_GRID_ROW: ZERO,
    START_FIRST_COL_SPAN_INDEX: ZERO,
    ZERO_SCORE_VALUE: ZERO,
};

export const CLASS_NAME = {
    SORTING_SPACE: 'sorting-space',
    WIDE_COLUMN: 'wide-column',
    SECOND_COLUMN: 'second-column',
    LEFT_ALIGN: 'left-align',
    MIDDLE_COLUMN: 'middle-column',
};

export const GATING_MAP = {
    [DISCONTINUE]: "Discont'd",
    [TESTED_OUT]: 'Tested Out',
};
